export default "__VITE_ASSET__D$RTRAgR__"